import React from 'react';
import { ShowDataFor } from 'utils/components/ShowDataFor/ShowDataFor';
import WidgetSettingsDropdownEditor from 'widgets/WidgetSettingsEditing/WidgetSettingsDropdownEditor';

export interface WidgetConfigWithShowDataFor {
    showDataFor?: ShowDataFor;
}

export interface WidgetShowDataForEditorProps {
    config: WidgetConfigWithShowDataFor;
    onChange: (delta: Partial<WidgetConfigWithShowDataFor>) => void;
}

export default function WidgetSettingsShowDataForEditor(
    props: WidgetShowDataForEditorProps
) {
    const { config, onChange } = props;

    return (
        <WidgetSettingsDropdownEditor
            className="show-data-for-dropdown"
            config={config}
            propertyName={'showDataFor'}
            label={'Show Data For'}
            options={[
                {
                    text: 'All Day',
                    value: ShowDataFor.AllDay,
                },
                {
                    text: 'Last 30 Mins',
                    value: ShowDataFor.Last30Mins,
                },
                {
                    text: 'Last Hour',
                    value: ShowDataFor.LastHour,
                },
                {
                    text: 'Last 2 Hours',
                    value: ShowDataFor.Last2Hours,
                },
            ]}
            onChange={onChange}
        />
    );
}
